import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          top: 64,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {},
        modal: {
          top: '64px !important',
        },
        paper: {
          top: 64,
          backgroundColor: '#e9f1ec',
        },
      },
    },
  },
});
